import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import { formFields, formFields1 } from './formField';
import { isEmpty, omit } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { FormField } from 'components';
import styles from './terms.module.scss';

const Terms = () => {
  const [form] = useForm();
  const user = useSelector(state => state.user);
  const appDetails = useSelector(state => state.appTrack.apptrackDetails);
  const localTaskVariables = appDetails?.localTaskVariables;
  const apptrackDetails =
    isEmpty(localTaskVariables) ||
    appDetails.activeTaskName !== 'task.name.submit_application'
      ? appDetails?.variablesIndexed
      : localTaskVariables;
  const carrier = useSelector(state => state.forms.carrier);
  const viewMode = true;

  return (
    <div style={{marginBottom: 120}} className={styles.termsWrapper}>
      <Form
        form={form}
        trigger="onChange"
        initialValues={{
          terms1: true,
          terms2: true,
          terms3: true,
          terms4: true,
          terms5: true,
          terms6: true,
          terms7: true,
          terms8: true,
          terms9: true,
          terms10: true,
          terms11: true,
          terms12: true,
          terms13: true,
          terms14: true,
        }}
      >
        <p className="mr-0 color-purple-1 text-bold font-size-24">
          Όροι και Προϋποθέσεις
        </p>
        <p className="text-bold">
          Η υποβολή της Αίτησης Συμμετοχής στο Πρόγραμμα επέχει τη θέση
          Υπεύθυνης Δήλωσης του Ν. 1599/1986.Ενεργώντας ως νόμιμος εκπρόσωπος
          της επιχείρησης για τους σκοπούς υποβολής της παρούσας αίτησης, δηλώνω
          υπεύθυνα ότι η επιχείρηση:{' '}
        </p>
        <Row style={{ width: '93%' }}>
          {formFields.map((field, index) => {
            return (
              <Col key={index} className="gutter-row" span={24}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                  valuePropName="checked"
                >
                  <FormField
                    key={index}
                    disabled={viewMode}
                    style={
                      viewMode
                        ? { pointerEvents: 'none', cursor: 'not-allowed' }
                        : {}
                    }
                    className={viewMode ? 'custom-checkbox-disabled' : ''}
                    {...omit(field, ['span', 'rules'])}
                  />
                </Form.Item>
              </Col>
            );
          })}
        </Row>
        <p className="text-bold">
          Επίσης, ενεργώντας ως νόμιμος εκπρόσωπος της επιχείρησης για τους
          σκοπούς υποβολής της παρούσας αίτησης, δηλώνω υπεύθυνα ότι:
        </p>
        <Row style={{ width: '91%' }}>
          {formFields1.map((field, index) => {
            return (
              <Col key={index} className="gutter-row" span={24}>
                <Form.Item
                  name={[field.name]}
                  rules={field.rules}
                  valuePropName="checked"
                >
                  <FormField
                    key={index}
                    disabled={viewMode}
                    style={
                      viewMode
                        ? { pointerEvents: 'none', cursor: 'not-allowed' }
                        : {}
                    }
                    className={viewMode ? 'custom-checkbox-disabled' : ''}
                    {...omit(field, ['span', 'rules'])}
                  />
                </Form.Item>
              </Col>
            );
          })}
        </Row>
      </Form>
    </div>
  );
};

export default Terms;
